// removed by extract-text-webpack-plugin
module.exports = {"map":"j6_j7"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventDetail/CourseMapImages/styles.module.css
// module id = 1265
// module chunks = 27